import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { cover, rem } from 'polished'
import { COLOR, MAX_CONTENT_WIDTH } from 'Theme'
import { fullWidthStyle, getMaxWidthStyle } from 'components/mixins'
import cubeImage from 'images/svg/graphic-cube-white.svg'

const StyledHero = styled('div')`
  ${fullWidthStyle}

  background-color: ${COLOR.BLACK};
`

const Content = styled('div')`
  ${getMaxWidthStyle(MAX_CONTENT_WIDTH.ARTICLE)};

  position: relative;
  top: ${rem(150)};

  margin-bottom: ${rem(150)};
`

const CubeLayer = styled('div')`
  ${cover()}

  overflow: hidden;
  user-select: none;
  pointer-events: none;
`

const CubeImage = styled('img').attrs({
  src: cubeImage,
  alt: '',
})`
  position: absolute;

  width: ${rem(320)};
  height: ${rem(320)};
`

const Hero = ({ children }) => (
  <StyledHero>
    <CubeLayer>
      <CubeImage style={{ top: rem(150), right: rem(-60) }} />
      <CubeImage style={{ bottom: rem(-60), left: rem(-30) }} />
    </CubeLayer>
    <Content>{children}</Content>
  </StyledHero>
)

Hero.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Hero
